import {
    assetListViewAttributesReceived,
    editAssetDataAction,
    editAssetFormDataReceived,
    getAssets,
    getProposedAssets,
    receivedAssetConfigData,
    receivedAssetData,
    receivedDefaultPolygonAssetData,
    receivedPolygonAssetData,
    receivedSegmentAssetData,
    setAssetsParams,
    setIsAnyAssetPublished,
    setIsAssetCreatedOrEdited,
    setProposedAssetMarkers,
    setProposedAssetsParams,
    setSegmentPointAssetData,
    setSelectedAssetColumns,
    setSelectedAssetConfigId,
    setSelectedAssetIds,
    setSelectedPolygonAssetIds,
    setSelectedRowIds,
    showAssetListView,
    showExistingAssetListView,
    showExistingSubAssetListView,
    storeAssets,
    setSelectedSubAssets,
    storeEnabledAssetIds,
    storeExistingPolygonAssetsData,
    storeGeoserverAssetsData,
    storeProposedAssets,
    storeRealTimePolygonData,
    toggleAssetActionPerformed,
    toggleCreatePolygonAssetPanel,
    toggleEditAssetPanel,
    toggleEditPolygonAssetPanel
} from "actions";
import { AssetDataStateInterface } from "../actions/Assets/types";

import { defaultGetResponse } from "../interfaces/ActionReducer/GetMethod/GetResponse";
import { defaultGeoserverAssetData } from "../interfaces/Geoserver";
import { createReducer } from "@reduxjs/toolkit";
import { resetStateRTK } from "components/curb/ManagerAnalyzer/Toggle/commonUtilities";
import { act } from "@testing-library/react";

const initialState: AssetDataStateInterface = {
    assetConfigData: defaultGetResponse,
    assetData: defaultGetResponse,
    assetListViewAttributes: [],
    editAssetFormData: {},
    geoserverAssetsData: defaultGeoserverAssetData,
    assetAction: {
        isAssetCreatedOrEdited: false,
        assetType: ""
    },
    isCreatePolygonAssetPanelOpen: false,
    isEditAssetPanelOpen: false,
    isEditPolygonAssetPanelOpen: false,
    polygonAssetData: defaultGetResponse,
    defaultPolygonAssetData: defaultGetResponse,
    proposedAssetMarkers: {},
    proposedAssets: defaultGetResponse,
    assets: defaultGetResponse,
    isAllProposedAssetsFetching: false,
    isAllAssetsFetching: false,
    proposedAssetsParams: {},
    AssetsParams: {},
    realTimePolygonData: [],
    segmentAssetData: defaultGetResponse,
    segmentPointAssets: {},
    selectedAssetConfigId: "",
    selectedAssetIds: [],
    selectedColumns: [],
    selectedPolygonAssetIds: [],
    selectedRowIds: [],
    showAssetListView: false,
    showExistingAssetListView: false,
    showExistingSubAssetListView: false,
    selectedSubAssetData: [],
    existingPolygonAssetsData: [],
    isAnyAssetPublished: false,
    assetActionPerformed: false,
    enabledIds: [],
    editAssetData: []
};

const AssetData = createReducer(initialState, (builder) => {
    builder
        .addCase(receivedAssetConfigData, (state, action) => {
            state.assetConfigData = action.payload.assetConfigData;
        })
        .addCase(receivedAssetData, (state, action) => {
            state.assetData = action.payload.assetData;
        })
        .addCase(storeEnabledAssetIds, (state, action) => {
            state.enabledIds = action.payload.enabledIds;
        })
        .addCase(receivedPolygonAssetData, (state, action) => {
            state.polygonAssetData = action.payload.assetData;
        })
        .addCase(receivedDefaultPolygonAssetData, (state, action) => {
            state.defaultPolygonAssetData = action.payload.assetData;
        })
        .addCase(setSelectedAssetColumns, (state, action) => {
            state.selectedColumns = action.payload.selectedColumns;
        })
        .addCase(receivedSegmentAssetData, (state, action) => {
            state.segmentAssetData = action.payload.assetData;
        })
        .addCase(setSelectedAssetIds, (state, action) => {
            state.selectedAssetIds = action.payload.selectedIds;
        })
        .addCase(setSegmentPointAssetData, (state, action) => {
            state.segmentPointAssets = action.payload.data;
        })
        .addCase(editAssetFormDataReceived, (state, action) => {
            state.editAssetFormData = action.payload.formData;
        })
        .addCase(setSelectedPolygonAssetIds, (state, action) => {
            state.selectedPolygonAssetIds = action.payload.selectedPolygonIds;
        })
        .addCase(toggleEditAssetPanel, (state, action) => {
            state.isEditAssetPanelOpen = action.payload.isEditAssetPanelOpen;
        })
        .addCase(getProposedAssets, (state) => {
            state.isAllProposedAssetsFetching = true;
        })
        .addCase(getAssets, (state) => {
            state.isAllAssetsFetching = true;
        })
        .addCase(setSelectedSubAssets, (state, action) => {
            state.selectedSubAssetData = action.payload.selectedSubAssetData;
        })
        .addCase(storeProposedAssets, (state, action) => {
            state.isAllProposedAssetsFetching = false;
            state.proposedAssets = action.payload.params;
        })
        .addCase(storeAssets, (state, action) => {
            state.isAllAssetsFetching = false;
            state.assets = action.payload.params;
        })
        .addCase(setProposedAssetMarkers, (state, action) => {
            state.proposedAssetMarkers = action.payload.params;
        })
        .addCase(assetListViewAttributesReceived, (state, action) => {
            state.assetListViewAttributes = action.payload.data;
        })
        .addCase(setProposedAssetsParams, (state, action) => {
            state.proposedAssetsParams = action.payload.data;
        })
        .addCase(setAssetsParams, (state, action) => {
            state.AssetsParams = action.payload.data;
        })
        .addCase(showAssetListView, (state, action) => {
            state.showAssetListView = action.payload.show;
        })
        .addCase(showExistingAssetListView, (state, action) => {
            state.showExistingAssetListView = action.payload.show;
        })
        .addCase(showExistingSubAssetListView, (state, action) => {
            state.showExistingSubAssetListView = action.payload.show;
        })
        .addCase(setIsAssetCreatedOrEdited, (state, action) => {
            state.assetAction = action.payload.assetAction;
        })
        .addCase(setSelectedRowIds, (state, action) => {
            state.selectedRowIds = action.payload.selectedRowIds;
        })
        .addCase(storeGeoserverAssetsData, (state, action) => {
            state.geoserverAssetsData = action.payload.geoserverAssetsData;
        })
        .addCase(setSelectedAssetConfigId, (state, action) => {
            state.selectedAssetConfigId = action.payload.selectedAssetConfigId;
        })
        .addCase(toggleEditPolygonAssetPanel, (state, action) => {
            state.isEditPolygonAssetPanelOpen = action.payload.isEditPolygonAssetPanelOpen;
        })
        .addCase(toggleCreatePolygonAssetPanel, (state, action) => {
            state.isCreatePolygonAssetPanelOpen = action.payload.isCreatePolygonAssetPanelOpen;
        })
        .addCase(storeRealTimePolygonData, (state, action) => {
            state.realTimePolygonData = action.payload.realTimePolygonData;
        })
        .addCase(storeExistingPolygonAssetsData, (state, action) => {
            state.existingPolygonAssetsData = action.payload.existingPolygonAssetsData;
        })
        .addCase(setIsAnyAssetPublished, (state, action) => {
            state.isAnyAssetPublished = action.payload.isAnyAssetPublished;
        })
        .addCase(toggleAssetActionPerformed, (state) => {
            state.assetActionPerformed = !state.assetActionPerformed;
        })
        .addCase(editAssetDataAction, (state, action) => {
            state.editAssetData = action.payload;
        })
        .addCase(resetStateRTK, () => initialState)
        .addDefaultCase((state) => state);
});

export default AssetData;
